import api from "./api";

// Wraps the `what-if-scenario-to-be` NestJS module (see
// what_if_scenario_to_be_documentation.md for the full contract). This is
// the real backend for the What-If Analysis "Save Scenario" / "Compare
// Scenario" tabs — a different module from the older, unused
// scenarioService.js (`/resource-management-ai`), which predates this
// feature and doesn't cover RACI/queuing detail.

const buildQuery = (params) => {
  const usp = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value != null && value !== "") usp.set(key, value);
  });
  const qs = usp.toString();
  return qs ? `?${qs}` : "";
};

/** @param {Object} payload - see buildScenarioToBePayload in utils/whatif/whatIfScenarioToBe.js */
export async function createWhatIfScenarioToBe(payload) {
  try {
    return await api.post("/what-if-scenario-to-be", payload);
  } catch (error) {
    console.error("Error creating what-if scenario:", error);
    throw error;
  }
}

/** List scenarios, optionally filtered to one process/company. */
export async function getWhatIfScenariosToBe({ processId, companyId } = {}) {
  try {
    const response = await api.get(
      `/what-if-scenario-to-be${buildQuery({ processId, companyId })}`,
    );
    return Array.isArray(response) ? response : response?.items || [];
  } catch (error) {
    console.error("Error fetching what-if scenarios:", error);
    throw error;
  }
}

/** Full scenario detail, including raciMatrixToBe and queuingAnalysis. */
export async function getWhatIfScenarioToBeById(id) {
  if (!id) throw new Error("Scenario ID is required");
  try {
    return await api.get(`/what-if-scenario-to-be/${id}`);
  } catch (error) {
    console.error(`Error fetching what-if scenario ${id}:`, error);
    throw error;
  }
}

export async function updateWhatIfScenarioToBe(id, payload) {
  if (!id) throw new Error("Scenario ID is required");
  try {
    return await api.patch(`/what-if-scenario-to-be/${id}`, payload);
  } catch (error) {
    console.error(`Error updating what-if scenario ${id}:`, error);
    throw error;
  }
}

export async function deleteWhatIfScenarioToBe(id) {
  if (!id) throw new Error("Scenario ID is required");
  try {
    await api.delete(`/what-if-scenario-to-be/${id}`);
  } catch (error) {
    console.error(`Error deleting what-if scenario ${id}:`, error);
    throw error;
  }
}

export async function getRaciMatrixToBeItems(id) {
  if (!id) throw new Error("Scenario ID is required");
  try {
    return await api.get(`/what-if-scenario-to-be/${id}/raci`);
  } catch (error) {
    console.error(`Error fetching RACI items for scenario ${id}:`, error);
    throw error;
  }
}

export async function addRaciMatrixToBeItems(id, items) {
  if (!id) throw new Error("Scenario ID is required");
  try {
    return await api.post(`/what-if-scenario-to-be/${id}/raci`, items);
  } catch (error) {
    console.error(`Error adding RACI items to scenario ${id}:`, error);
    throw error;
  }
}

export async function getQueuingAnalysisItems(id) {
  if (!id) throw new Error("Scenario ID is required");
  try {
    return await api.get(`/what-if-scenario-to-be/${id}/queuing`);
  } catch (error) {
    console.error(`Error fetching queuing items for scenario ${id}:`, error);
    throw error;
  }
}

export async function addQueuingAnalysisItems(id, items) {
  if (!id) throw new Error("Scenario ID is required");
  try {
    return await api.post(`/what-if-scenario-to-be/${id}/queuing`, items);
  } catch (error) {
    console.error(`Error adding queuing items to scenario ${id}:`, error);
    throw error;
  }
}
